import React from 'react'
import PropTypes from 'prop-types'
import { Card, ToggleButtonGroup, ToggleButton } from '@mui/material'
import T from 'T'

const GoogleMapTypeControl = ({ value, onChange, sx }) => {
  return (
    <Card sx={{ ...sx }}>
      <ToggleButtonGroup value={value} exclusive onChange={onChange} aria-label="map type" size="small">
        <ToggleButton value="roadmap" aria-label="roadmap">
          {T.MAP}
        </ToggleButton>
        <ToggleButton value="satellite" aria-label="satellite">
          {T.SATELLITE}
        </ToggleButton>
      </ToggleButtonGroup>
    </Card>
  )
}

GoogleMapTypeControl.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
}

export default GoogleMapTypeControl
